import React, {
  useMemo,
  forwardRef,
  useCallback,
  createContext,
} from 'react';
import PropTypes from 'prop-types';
import { RadioButtonGroup } from '../../../RadioButtonGroup';
import { Base } from '../Base';

export const radioButtonsFieldContext = createContext(null);

export const RadioButtonGroupField = forwardRef((props, ref) => {
  const {
    id,
    name,
    value,
    error,
    onBlur,
    variant,
    children,
    onChange,
    ...contentProps
  } = props;
  const radioButtonsFieldValue = useMemo(() => ({
    name,
    value,
    error,
  }), [name, value, error]);

  const handleChange = useCallback((ev) => {
    onBlur();
    onChange(ev);
  }, [onBlur, onChange]);

  return (
    <Base
      id={id}
      name={name}
      error={error}
      {...contentProps}
    >
      <radioButtonsFieldContext.Provider value={radioButtonsFieldValue}>
        <RadioButtonGroup
          id={`${id}-group`}
          ref={ref}
          name={name}
          value={value}
          onBlur={onBlur}
          isInvalid={!!error}
          onChange={handleChange}
          variant={variant}
          flexWrap="wrap"
          rowGap="0.75rem"
        >
          {children}
        </RadioButtonGroup>
      </radioButtonsFieldContext.Provider>
    </Base>
  );
});

RadioButtonGroupField.defaultProps = {
  value: '',
  error: null,
  children: null,
  onBlur: () => {},
  onChange: () => {},
};

RadioButtonGroupField.propTypes = {
  onBlur: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.shape({ message: PropTypes.string }),
  children: PropTypes.node,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
};
